import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const HouseKeepingInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="House Keeping"
    sectionDisplayName="House Keeping"
    backRoute="/sections/house-keeping"
  />
);

export default HouseKeepingInwardConsignment;
